import React, { useEffect, useRef, useState } from 'react';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

import ComparablesRow from './comparablesRow';
import { colors } from '../../../constants';
import '../scoutComparables.css';

const getWeightsFromComps = (comps) => {
    const wts = {};
    comps.forEach((comp) => (wts[comp.pid] = comp?.weight));
    return wts;
};

const WeightLabel = ({ onCancel, onSave }) => (
    <div className="d-flex flex-column">
        <div>Weight</div>
        <div>
            <button className={'btn p-0'} onClick={onSave}>
                <span
                    style={{
                        color: colors.aroGreen,
                        lineHeight: '18px',
                        fontSize: '18px',
                        fontWeight: 600,
                    }}
                >
          &#10003;
                </span>
            </button>
            <button className={'btn p-0 ms-2'} onClick={onCancel}>
                <span style={{ lineHeight: '14px', fontSize: '14px', fontWeight: 500 }}>
          X
                </span>
            </button>
        </div>
    </div>
);

const ComparablesTable = ({
    comps,
    keyId,
    onSelect,
    editOK,
    onSave,
    onCancel,
    onRemove,
}) => {
    const tableRef = useRef(null);
    const [weights, setWeights] = useState(() => getWeightsFromComps(comps));

    useEffect(() => {
        const tableEl = tableRef.current;
        if (!tableEl) return;
        return dropTargetForElements({
            element: tableEl,
            // onDragStart: () => setIsDraggedOver(true),
            // onDragEnter: () => setIsDraggedOver(true),
            // onDragLeave: () => setIsDraggedOver(false),
            // onDrop: () => setIsDraggedOver(false),
            getData: () => ({ keyId }),
            getIsSticky: () => true,
        });
    }, [keyId]);

    useEffect(() => {
        setWeights(getWeightsFromComps(comps));
    }, [comps]);

    const handleChangeWeight = (id, value) => {
        const newWeights = { ...weights };
        newWeights[id] = value;
        setWeights(newWeights);
    };

    const handleSave = () => {
        onSave(weights);
    };

    const handleCancel = () => {
        setWeights(getWeightsFromComps(comps));
        onCancel();
    };

    return (
        <div className="table-responsive">
            <table className="table" ref={tableRef}>
                <thead>
                    <tr>
                        <th scope="col" className="fw-normal comparableAddress">
              Property Address
                        </th>
                        <th scope="col" className="fw-normal">
              Date Sold
                        </th>
                        <th scope="col" className="fw-normal">
              Distance
                        </th>
                        <th scope="col" className="fw-normal">
              Bld.Size
                        </th>
                        <th scope="col" className="fw-normal">
              Yr Built
                        </th>
                        <th scope="col" className="fw-normal text-center">
              $/SF
                        </th>
                        <th scope="col" className="fw-normal">
              Price Sold
                        </th>
                        <th
                            scope="col"
                            className="fw-normal pe-1 text-center comparableWeight"
                        >
                            {editOK ? (
                                <WeightLabel onSave={handleSave} onCancel={handleCancel} />
                            ) : (
                                'Weight'
                            )}
                        </th>
                        <th scope="col"></th>
                        <th className="spacerColumn" />
                    </tr>
                </thead>

                <tbody>
                    {comps.map((prop) => (
                        <ComparablesRow
                            key={`${keyId}-${prop.pid}`}
                            prop={{ ...prop, weight: weights[prop.pid] }}
                            onSelect={onSelect}
                            onChangeWeight={editOK ? handleChangeWeight : null}
                            onRemove={onRemove}
                            removeOK={!editOK}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ComparablesTable;
